import _Abstract from "system/abstract"

export default class Module_TwoColVerticallyStackedTiles extends _Abstract {
    constructor(el, options) {
        super(el, $.extend(true, {}, options), 'module')
        this.initialise();

        var LAZY_LOAD_TILES_OFF_SCREEN = true;

        this.orderedType = "";
    }


    initialise()
    {
        this.cacheElements();
        this.setOrderNumbersOnElements();
        this.initialiseListeners();
        this.reorderElements();
    }

    setOrderNumbersOnElements()
    {
        this.$tileContent.find("> *").each(function(index,value)
        {
            $(this).attr("data-index",index);
        });
    }

    cacheElements()
    {
        this.$tileContent = this.$el.find(".m-two-col-vertically-stacked-tiles-content");
        this.$firstContentContainer = this.$el.find(".-first-content-container");
        this.$secondContentCotainer = this.$el.find(".-second-content-container");
    }


    initialiseListeners()
    {
        $(window).resize((e) => this.onWindowResized(e));
        $("body").on('reorder-items',()=>this.onReorderElementsEventTriggered())
    }

    onWindowResized(_event)
    {
        this.reorderElements();
    }

    onReorderElementsEventTriggered(_event)
    {
        this.reorderElements(true);
    }

    reorderElements(_forceReorder)
    {
        if(typeof _forceReorder === "undefined")
        {
            _forceReorder = false;
        }

        var desktopBreakpointSize = $("#bp-desktop").width();

        var windowOuterWidth = $(window).outerWidth();

        var bDesktopSizeAndNewColumnType = windowOuterWidth >= desktopBreakpointSize && (this.orderedType !== "two-col" || _forceReorder);
        var bMobileSizeAndNewColumnType = windowOuterWidth <  desktopBreakpointSize && (this.orderedType !== "one-col" || _forceReorder);

        if(bDesktopSizeAndNewColumnType || bMobileSizeAndNewColumnType)
        {
            this.$tileContent.append(this.$firstContentContainer.find(" > a").detach());
            this.$tileContent.append(this.$secondContentCotainer.find(" > a").detach());
            this.setTileContentInOriginalOrder();
            var $tileItems = this.$tileContent.find(" > a");
            var $dataResponsiveImages = $tileItems.find("[data-responsive-image]");
            $dataResponsiveImages.removeClass("-defer-loading");

            if(bDesktopSizeAndNewColumnType)
            {
                var context = this;
                var $nonHiddenItems = $tileItems.not('.-hide');

                $nonHiddenItems.each(function()
                {
                    var $smallestTileContainer = context.getSmallestHeightTileContainer();
                    $smallestTileContainer.append(this);
                });

                $tileItems.not(':not(.-hide)').each(function()
                {
                    var $smallestTileContainer = context.getSmallestHeightTileContainer();
                    $smallestTileContainer.append(this);
                });

                this.orderedType = "two-col";
            }
            else if(bMobileSizeAndNewColumnType)
            {
                this.$firstContentContainer.append($tileItems);
                this.orderedType = "one-col";
            }

            $("body").trigger("responsive-image",{"$responsiveImageTargets":$dataResponsiveImages});

        }
    }


    setTileContentInOriginalOrder()
    {
        var bAscendingOrder = this.$el.hasClass("-ascending-order");

        var $detachedItems = this.$tileContent.find("> *").detach();
        if(bAscendingOrder)
        {
            $detachedItems.sort(function(a,b)
            {
                return (+b.getAttribute("data-index")) - (+a.getAttribute("data-index"))
            }).appendTo(this.$tileContent);
        }
        else
        {
            $detachedItems.sort(function(a,b)
            {
                return (+a.getAttribute("data-index")) - (+b.getAttribute("data-index"))
            }).appendTo(this.$tileContent);
        }
    }

    getFirstContainerTileHeight()
    {
        return this.getHeightOfTilesInContainer(this.$firstContentContainer);
    }

    getSecondContainerTileHeight()
    {
        return this.getHeightOfTilesInContainer(this.$secondContentCotainer);
    }

    getHeightOfTilesInContainer(_$container)
    {
        var $tiles = _$container.find("> a");
        var height = 0;
        $tiles.each(function()
        {
            height += $(this).height();
        })

        return height;
    }


    getSmallestHeightTileContainer()
    {
        if(this.getFirstContainerTileHeight() <= this.getSecondContainerTileHeight())
        {
            return this.$firstContentContainer;
        }
        else
        {
            return this.$secondContentCotainer;
        }
    }


}




/** WEBPACK FOOTER **
 ** ./modules/two-col-vertically-stacked-tiles.js
 **/